import { render } from "./SpeechLine.vue?vue&type=template&id=2d3922cc&bindings={\"color\":\"props\",\"text\":\"props\",\"measure\":\"props\",\"pos\":\"props\",\"style\":\"options\"}"
import script from "./SpeechLine.vue?vue&type=script&lang=js"
export * from "./SpeechLine.vue?vue&type=script&lang=js"

import "./SpeechLine.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script